// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"375":"dbe87b09","652":"355d989f"}[chunkId] + ".css";
};